import { Directive, Input, Signal } from "@angular/core";
import { PublicationTemplateFields } from "../../data/entities/publication-template-fields.entity";

@Directive()
export class PublicationTemplateRulesBoxComponent<
  T extends PublicationTemplateFields,
> {
  @Input({ required: true }) public fields!: Signal<T>;
}
